(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rotating-bullets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('rotating-bullets')) return;

    class RotatingBullets extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.rotating-bullets__item'));
        if (this.items.length < 2) return;

        this.intervalMs = Number(this.dataset.interval) || 4000;
        this.enableMobile = this.dataset.enableMobile !== 'false';
        this.enableDesktop = this.dataset.enableDesktop !== 'false';
        this.enterMs = 1200;
        this.exitMs = 1100;
        this.overlapMs = 280;
        this.isAnimating = false;
        this.mqDesktop = window.matchMedia('(min-width: 750px)');
        this.mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.boundPause = () => this.pause();
        this.boundResume = () => this.resume();
        this.boundSync = () => this.syncMode();

        this.addEventListener('pointerenter', this.boundPause);
        this.addEventListener('pointerleave', this.boundResume);
        this.addEventListener('pointercancel', this.boundResume);
        this.addEventListener('focusin', this.boundPause);
        this.addEventListener('focusout', this.boundResume);
        this.mqDesktop.addEventListener('change', this.boundSync);
        this.mqReduced.addEventListener('change', this.boundSync);

        this.index = this.items.findIndex((item) => item.classList.contains('is-active'));
        if (this.index < 0) this.index = 0;

        this.syncMode();
      }

      disconnectedCallback() {
        this.stop();
        this.clearAnimationTimers();
        this.removeEventListener('pointerenter', this.boundPause);
        this.removeEventListener('pointerleave', this.boundResume);
        this.removeEventListener('pointercancel', this.boundResume);
        this.removeEventListener('focusin', this.boundPause);
        this.removeEventListener('focusout', this.boundResume);
        this.mqDesktop?.removeEventListener('change', this.boundSync);
        this.mqReduced?.removeEventListener('change', this.boundSync);
      }

      isEnabledForViewport() {
        return this.mqDesktop.matches ? this.enableDesktop : this.enableMobile;
      }

      clearAnimationTimers() {
        if (this.overlapTimer) {
          window.clearTimeout(this.overlapTimer);
          this.overlapTimer = null;
        }
        if (this.exitDoneTimer) {
          window.clearTimeout(this.exitDoneTimer);
          this.exitDoneTimer = null;
        }
        if (this.enterDoneTimer) {
          window.clearTimeout(this.enterDoneTimer);
          this.enterDoneTimer = null;
        }
        this.isAnimating = false;
      }

      resetItemClasses(item) {
        item.classList.remove('is-active', 'is-entering', 'is-exiting');
      }

      syncMode() {
        this.stop();
        this.clearAnimationTimers();

        if (!this.isEnabledForViewport() || this.mqReduced.matches) {
          this.classList.add('is-static');
          this.setAttribute('data-reduced-motion', '');
          this.items.forEach((item) => {
            this.resetItemClasses(item);
            item.classList.add('is-active');
            item.removeAttribute('aria-hidden');
          });
          return;
        }

        this.classList.remove('is-static');
        this.removeAttribute('data-reduced-motion');
        this.items.forEach((item, i) => {
          this.resetItemClasses(item);
          if (i === this.index) {
            item.classList.add('is-active');
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });
        this.start();
      }

      start() {
        this.stop();
        if (!this.isEnabledForViewport() || this.mqReduced.matches) return;
        this.timer = window.setInterval(() => this.next(), this.intervalMs);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      pause() {
        this.stop();
      }

      resume() {
        if (!this.timer && !this.isAnimating) this.start();
      }

      next() {
        if (this.isAnimating) return;

        const current = this.items[this.index];
        const nextIndex = (this.index + 1) % this.items.length;
        const next = this.items[nextIndex];
        this.isAnimating = true;
        this.index = nextIndex;

        current.classList.remove('is-active', 'is-entering');
        current.classList.add('is-exiting');
        current.setAttribute('aria-hidden', 'true');

        this.overlapTimer = window.setTimeout(() => {
          next.classList.remove('is-exiting');
          next.classList.add('is-active', 'is-entering');
          next.removeAttribute('aria-hidden');

          this.enterDoneTimer = window.setTimeout(() => {
            next.classList.remove('is-entering');
            this.isAnimating = false;
          }, this.enterMs);
        }, this.overlapMs);

        this.exitDoneTimer = window.setTimeout(() => {
          current.classList.remove('is-exiting');
        }, this.exitMs);
      }
    }

    customElements.define('rotating-bullets', RotatingBullets);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trial-product-card"] && !Shopify.designMode) return;
  try {
    (() => {

    if (window.__trialProductCardBound) return;

    window.__trialProductCardBound = true;


    /* =======================================================
       GENERAL HELPERS
       ======================================================= */

    const getSealContainer = () =>
      document.querySelector('.sls-purchase-options-container') ||
      document.querySelector('.sealsubs-target-element');


    const getMainProductFormComponent = () =>
      document.querySelector(
        '.buy-buttons-block product-form-component'
      ) ||
      [...document.querySelectorAll('product-form-component')]
        .find((component) => {

          return (
            !component.closest('[data-trial-root]') &&
            component.querySelector(
              'form input[name="id"]'
            )
          );

        }) ||
      null;


    const getTrialCheckout = (root) => {

      if (!root) return null;

      const key = root.dataset.trialKey;

      if (!key) return null;

      return [...document.querySelectorAll('[data-trial-checkout]')]
        .find((checkout) => {

          return (
            checkout.dataset.trialCheckout === key
          );

        }) || null;

    };


    const getSelectedTrialRoot = () => {

      const toggle =
        document.querySelector(
          '.trial-purchase-option[data-trial-root] [data-trial-toggle].is-open'
        );

      return toggle?.closest('[data-trial-root]') || null;

    };


    /* =======================================================
       PLACE TRIAL SELECTOR UNDER SEAL
       ======================================================= */

    const placeUnderSeal = () => {

      document
        .querySelectorAll('[data-trial-place-under-seal]')
        .forEach((el) => {

          if (el.dataset.placed === 'true') return;

          const sealContainer =
            getSealContainer();

          if (!sealContainer) return;

          sealContainer.appendChild(el);

          el.dataset.placed = 'true';

        });

    };


    /* =======================================================
       PLACE TRIAL SHOP PAY DIRECTLY BELOW MAIN BUY BUTTONS

       IMPORTANT:
       This keeps the trial's product form OUTSIDE the
       30-day product form.

       We never nest Shopify product forms.
       ======================================================= */

    const placeTrialCheckout = () => {

      const mainComponent =
        getMainProductFormComponent();

      if (!mainComponent) return;


      document
        .querySelectorAll('[data-trial-checkout]')
        .forEach((checkout) => {

          if (
            checkout.dataset.checkoutPlaced === 'true'
          ) {
            return;
          }

          mainComponent.insertAdjacentElement(
            'afterend',
            checkout
          );

          checkout.dataset.checkoutPlaced = 'true';

        });

    };


    placeUnderSeal();

    placeTrialCheckout();


    let attempts = 0;

    const placementTimer =
      window.setInterval(() => {

        placeUnderSeal();

        placeTrialCheckout();

        attempts += 1;

        const waitingForSeal =
          document.querySelectorAll(
            '[data-trial-place-under-seal]:not([data-placed="true"])'
          ).length > 0;

        const waitingForCheckout =
          document.querySelectorAll(
            '[data-trial-checkout]:not([data-checkout-placed="true"])'
          ).length > 0;

        if (
          attempts >= 40 ||
          (
            !waitingForSeal &&
            !waitingForCheckout
          )
        ) {

          window.clearInterval(
            placementTimer
          );

        }

      }, 250);


    /* =======================================================
       TRIAL UI STATE
       ======================================================= */

    const setTrialCheckoutState = (
      root,
      selected
    ) => {

      const checkout =
        getTrialCheckout(root);

      const secondary =
        root?.querySelector(
          '[data-trial-secondary]'
        );


      if (secondary) {

        secondary.hidden = !selected;

      }


      if (checkout) {

        checkout.hidden = !selected;

      }


      document.documentElement.classList.toggle(
        'sleepeq-trial-selected',
        Boolean(selected)
      );

    };


    const collapseTrial = (root) => {

      const toggle =
        root.querySelector(
          '[data-trial-toggle]'
        );

      if (toggle) {

        toggle.classList.remove(
          'is-open'
        );

        toggle.setAttribute(
          'aria-pressed',
          'false'
        );

      }

      const secondary =
        root.querySelector(
          '[data-trial-secondary]'
        );

      if (secondary) {

        secondary.hidden = true;

      }

      const checkout =
        getTrialCheckout(root);

      if (checkout) {

        checkout.hidden = true;

      }

    };


    const collapseAllTrials = () => {

      document
        .querySelectorAll(
          '.trial-purchase-option[data-trial-root]'
        )
        .forEach(collapseTrial);

      document.documentElement.classList.remove(
        'sleepeq-trial-selected'
      );

    };


    const clearTrialSealVisual = () => {

      getSealContainer()?.classList.remove(
        'is-trial-selected'
      );

      document.documentElement.classList.remove(
        'sleepeq-trial-selected'
      );

    };


    /* =======================================================
       SEAL HELPERS
       ======================================================= */

    const getSealRadios = (seal) =>
      [
        ...(
          seal?.querySelectorAll(
            'input.sls-option'
          ) || []
        )
      ];


    const getOneTimeRadio = (seal) => {

      const radios =
        getSealRadios(seal);

      return (
        radios.find(
          (radio) =>
            radio.value === 'one_time' ||
            radio.dataset.type === 'one_time'
        ) ||
        radios[0] ||
        null
      );

    };


    const getSealClickTarget = (el) => {

      if (!el) return null;

      const container =
        el.closest?.(
          '.sls-option-container'
        ) || el;

      return (
        container.querySelector(
          '.sls-selling-plan-group-first-line[role="radio"]'
        ) ||
        container.querySelector(
          '[role="radio"]'
        ) ||
        container.querySelector(
          'input.sls-option'
        ) ||
        container
      );

    };


    let syncingSeal = false;


    const syncTrialQuantity = (root) => {

      if (!root) return;

      const checkout =
        getTrialCheckout(root);

      if (!checkout) return;

      const trialQuantity =
        checkout.querySelector(
          '[data-trial-quantity]'
        );

      if (!trialQuantity) return;


      const mainForm =
        getMainProductFormComponent()
          ?.querySelector('form');


      const quantityInput =
        mainForm?.querySelector(
          'input[name="quantity"]'
        ) ||
        document.querySelector(
          '.buy-buttons-block input[name="quantity"]'
        );


      const quantity =
        Number.parseInt(
          quantityInput?.value || '1',
          10
        );


      trialQuantity.value =
        Number.isNaN(quantity) ||
        quantity < 1
          ? 1
          : quantity;

    };


    const applyTrialSealVisual = (root) => {

      const seal =
        getSealContainer();

      if (seal) {

        seal
          .querySelectorAll(
            '.sls-option-container'
          )
          .forEach((container) => {

            container.classList.remove(
              'sls-active'
            );

            container
              .querySelectorAll(
                '[role="radio"]'
              )
              .forEach((el) => {

                el.setAttribute(
                  'aria-checked',
                  'false'
                );

              });

          });

        seal.classList.add(
          'is-trial-selected'
        );

      }


      const toggle =
        root?.querySelector(
          '[data-trial-toggle]'
        );

      if (toggle) {

        toggle.classList.add(
          'is-open'
        );

        toggle.setAttribute(
          'aria-pressed',
          'true'
        );

      }


      syncTrialQuantity(root);

      setTrialCheckoutState(
        root,
        true
      );

    };


    const deselectSealOptions = (root) => {

      const seal =
        getSealContainer();


      if (!seal) {

        applyTrialSealVisual(root);

        return;

      }


      const oneTime =
        getOneTimeRadio(seal);


      const oneTimeTarget =
        getSealClickTarget(
          oneTime
        );


      /*
       * Internally reset Seal to one-time before Trial is
       * treated as selected.
       *
       * That prevents a subscription selling plan from
       * remaining attached behind the trial selection.
       */

      syncingSeal = true;


      if (oneTimeTarget) {

        oneTimeTarget.click();

      }


      window.setTimeout(() => {

        applyTrialSealVisual(root);

        syncingSeal = false;

      }, 40);

    };


    /* =======================================================
       CART HELPERS
       ======================================================= */

    const getCartAddUrl = () =>
      window.Theme?.routes?.cart_add_url ||
      `${window.Shopify?.routes?.root || '/'}cart/add.js`;


    const getSectionIds = () => {

      const ids = [];

      document
        .querySelectorAll(
          'cart-items-component'
        )
        .forEach((el) => {

          if (el.dataset.sectionId) {

            ids.push(
              el.dataset.sectionId
            );

          }

        });

      return ids;

    };


    const setButtonLabel = (
      button,
      label
    ) => {

      if (!button || !label) return;

      button.textContent = label;

    };


    const showError = (
      root,
      message
    ) => {

      const errorEl =
        root?.querySelector(
          '[data-trial-error]'
        );

      if (!errorEl) return;

      errorEl.hidden =
        !message;

      errorEl.textContent =
        message || '';

    };


    const afterAdd = (
      source,
      response
    ) => {

      const behavior =
        source?.dataset?.afterAdd ||
        'open_cart';

      const productUrl =
        source?.dataset?.productUrl;


      if (
        behavior === 'redirect_cart'
      ) {

        window.location.href =
          `${window.Shopify?.routes?.root || '/'}cart`;

        return;

      }


      if (
        behavior === 'redirect_product' &&
        productUrl
      ) {

        window.location.href =
          productUrl;

        return;

      }


      document.dispatchEvent(
        new CustomEvent(
          'cart:update',
          {

            bubbles: true,

            detail: {

              resource: response,

              sourceId:
                'trial-product-card',

              data: {

                source:
                  'trial-product-card',

                itemCount:
                  response?.item_count,

                variantId:
                  String(
                    source?.dataset?.variantId ||
                    ''
                  ),

                sections:
                  response?.sections || {},

              },

            },

          }
        )
      );

    };


    const getMainProductForm = (
      trigger
    ) => {

      const closestForm =
        trigger?.closest?.('form');


      if (
        closestForm &&
        closestForm.querySelector(
          'input[name="id"]'
        ) &&
        !closestForm.closest(
          '[data-trial-root]'
        ) &&
        !closestForm.classList.contains(
          'trial-purchase-option__native-form'
        )
      ) {

        return closestForm;

      }


      return (
        getMainProductFormComponent()
          ?.querySelector('form') ||
        null
      );

    };


    const getSelectedQuantity = (
      form
    ) => {

      const quantityInput =
        form?.querySelector(
          'input[name="quantity"]'
        ) ||
        document.querySelector(
          '.buy-buttons-block input[name="quantity"]'
        );


      const quantity =
        Number.parseInt(
          quantityInput?.value || '1',
          10
        );


      if (
        Number.isNaN(quantity) ||
        quantity < 1
      ) {

        return 1;

      }


      return quantity;

    };


    let trialAddInProgress =
      false;


    const addSelectedTrialToCart =
      async (
        root,
        trigger = null,
        productForm = null
      ) => {

        if (
          !root ||
          trialAddInProgress
        ) {

          return;

        }


        const variantId =
          Number(
            root.dataset.variantId
          );


        if (!variantId) {

          showError(
            root,
            'Unable to identify the trial product.'
          );

          return;

        }


        trialAddInProgress =
          true;


        showError(
          root,
          ''
        );


        if (trigger) {

          trigger.disabled =
            true;

        }


        try {

          const sectionIds =
            getSectionIds();


          const quantity =
            getSelectedQuantity(
              productForm ||
              getMainProductForm(
                trigger
              )
            );


          const payload = {

            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],

          };


          if (
            sectionIds.length
          ) {

            payload.sections =
              sectionIds.join(',');

          }


          const fetchResponse =
            await fetch(
              getCartAddUrl(),
              {

                method: 'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json',

                },

                body:
                  JSON.stringify(
                    payload
                  ),

              }
            );


          const response =
            await fetchResponse.json();


          if (
            !fetchResponse.ok ||
            response.status
          ) {

            showError(
              root,
              response.description ||
                response.message ||
                'Unable to add trial to cart'
            );

            return;

          }


          let cart =
            response;


          try {

            cart =
              await fetch(
                `${window.Shopify?.routes?.root || '/'}cart.js`
              ).then(
                (res) =>
                  res.json()
              );


            if (
              response.sections
            ) {

              cart.sections =
                response.sections;

            }

          } catch (_error) {

            cart =
              response;

          }


          afterAdd(
            root,
            cart
          );


        } catch (error) {

          console.error(
            'SleepEQ trial add-to-cart error:',
            error
          );


          showError(
            root,
            'Unable to add trial to cart'
          );


        } finally {

          if (trigger) {

            trigger.disabled =
              false;

          }


          trialAddInProgress =
            false;

        }

      };


    /* =======================================================
       QUANTITY SYNCHRONIZATION

       If the customer changes quantity while Trial is active,
       keep the native Trial Shop Pay form synchronized.
       ======================================================= */

    const handleQuantityChange =
      (event) => {

        const quantityInput =
          event.target.closest?.(
            'input[name="quantity"]'
          );


        if (
          !quantityInput ||
          quantityInput.closest(
            '.trial-purchase-option__native-form'
          )
        ) {

          return;

        }


        const root =
          getSelectedTrialRoot();


        if (root) {

          syncTrialQuantity(
            root
          );

        }

      };


    document.addEventListener(
      'input',
      handleQuantityChange
    );


    document.addEventListener(
      'change',
      handleQuantityChange
    );


    /* =======================================================
       SEAL RADIO CHANGES
       ======================================================= */

    document.addEventListener(
      'change',
      (event) => {

        if (
          syncingSeal
        ) {
          return;
        }


        const sealRadio =
          event.target.closest?.(
            'input.sls-option'
          );


        if (!sealRadio) {
          return;
        }


        clearTrialSealVisual();

        collapseAllTrials();

      }
    );


    /* =======================================================
       CLICK SUBSCRIBE OR ONE-TIME AFTER TRIAL
       ======================================================= */

    document.addEventListener(
      'click',
      (event) => {

        if (
          syncingSeal
        ) {
          return;
        }


        const sealOption =
          event.target.closest(
            '.sls-option-container'
          );


        if (
          !sealOption ||
          sealOption.closest(
            '[data-trial-root]'
          )
        ) {

          return;

        }


        const seal =
          getSealContainer();


        const comingFromTrial =
          seal?.classList.contains(
            'is-trial-selected'
          );


        if (
          !comingFromTrial
        ) {

          collapseAllTrials();

          return;

        }


        event.preventDefault();

        event.stopImmediatePropagation();


        clearTrialSealVisual();

        collapseAllTrials();


        const targetRadio =
          sealOption.querySelector(
            'input.sls-option'
          );


        const oneTime =
          getOneTimeRadio(
            seal
          );


        const oneTimeTarget =
          getSealClickTarget(
            oneTime
          );


        const optionTarget =
          getSealClickTarget(
            sealOption
          );


        syncingSeal =
          true;


        const finish = () => {

          if (
            optionTarget
          ) {

            optionTarget.click();

          }


          window.setTimeout(
            () => {

              syncingSeal =
                false;

            },
            40
          );

        };


        if (
          targetRadio &&
          oneTime &&
          targetRadio !==
            oneTime &&
          oneTimeTarget
        ) {

          oneTimeTarget.click();

          window.setTimeout(
            finish,
            50
          );

        } else {

          window.setTimeout(
            finish,
            0
          );

        }

      },
      true
    );


    /* =======================================================
       TRIAL RADIO OPTION
       ======================================================= */

    document.addEventListener(
      'click',
      (event) => {

        const toggle =
          event.target.closest(
            '[data-trial-toggle]'
          );


        if (!toggle) {
          return;
        }


        event.preventDefault();


        const root =
          toggle.closest(
            '[data-trial-root]'
          );


        if (!root) {
          return;
        }


        /*
         * Treat Trial as a true radio option.
         * Clicking an already-selected Trial does not deselect it.
         * The customer selects Subscribe or One-Time to leave Trial.
         */

        if (
          toggle.classList.contains(
            'is-open'
          )
        ) {

          return;

        }


        collapseAllTrials();


        toggle.classList.add(
          'is-open'
        );


        toggle.setAttribute(
          'aria-pressed',
          'true'
        );


        setTrialCheckoutState(
          root,
          true
        );


        syncTrialQuantity(
          root
        );


        deselectSealOptions(
          root
        );

      }
    );


    /* =======================================================
       MAIN ADD TO CART

       If Trial is selected, intercept the 30-day product form
       and add the Trial variant instead.

       Subscribe and One-Time continue using Horizon + Seal
       exactly as before.
       ======================================================= */

    document.addEventListener(
      'click',
      (event) => {

        const selectedTrial =
          getSelectedTrialRoot();


        if (!selectedTrial) {
          return;
        }


        const button =
          event.target.closest(
            [
              'button[id^="BuyButtons-ProductSubmitButton-"]',
              '.sticky-add-to-cart__button',
              'button[type="submit"][name="add"]'
            ].join(',')
          );


        if (!button) {
          return;
        }


        if (
          button.closest(
            '[data-trial-root]'
          ) ||
          button.closest(
            '.trial-purchase-option__native-form'
          )
        ) {

          return;

        }


        const productForm =
          getMainProductForm(
            button
          );


        const isMainProductButton =
          button.matches(
            'button[id^="BuyButtons-ProductSubmitButton-"]'
          ) ||
          button.matches(
            '.sticky-add-to-cart__button'
          ) ||
          Boolean(
            productForm
          );


        if (
          !isMainProductButton
        ) {

          return;

        }


        event.preventDefault();

        event.stopImmediatePropagation();


        addSelectedTrialToCart(
          selectedTrial,
          button,
          productForm
        );

      },
      true
    );


    /* =======================================================
       MAIN FORM SUBMIT FALLBACK

       Handles keyboard Enter or alternate Horizon submission.
       ======================================================= */

    document.addEventListener(
      'submit',
      (event) => {

        const selectedTrial =
          getSelectedTrialRoot();


        if (!selectedTrial) {
          return;
        }


        const form =
          event.target;


        if (
          !(
            form instanceof
            HTMLFormElement
          ) ||
          form.classList.contains(
            'trial-purchase-option__native-form'
          ) ||
          form.closest(
            '[data-trial-root]'
          ) ||
          !form.querySelector(
            'input[name="id"]'
          )
        ) {

          return;

        }


        event.preventDefault();

        event.stopImmediatePropagation();


        addSelectedTrialToCart(
          selectedTrial,
          event.submitter || null,
          form
        );

      },
      true
    );


    /* =======================================================
       STANDARD CARD-LAYOUT ADD TO CART

       Preserves Adeel's original functionality anywhere this
       block is used as a normal product card.
       ======================================================= */

    document.addEventListener(
      'click',
      async (event) => {

        const button =
          event.target.closest(
            '[data-trial-add]'
          );


        if (
          !button ||
          button.disabled
        ) {

          return;

        }


        event.preventDefault();


        const root =
          button.closest(
            '[data-trial-root]'
          );


        const variantId =
          Number(
            button.dataset.variantId
          );


        if (!variantId) {
          return;
        }


        const labelAdd =
          button.dataset.labelAdd ||
          'Add to cart';


        const labelAdding =
          button.dataset.labelAdding ||
          'Adding...';


        const labelAdded =
          button.dataset.labelAdded ||
          'Added to cart';


        showError(
          root,
          ''
        );


        button.disabled =
          true;


        setButtonLabel(
          button,
          labelAdding
        );


        try {

          const sectionIds =
            getSectionIds();


          const payload = {

            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],

          };


          if (
            sectionIds.length
          ) {

            payload.sections =
              sectionIds.join(',');

          }


          const fetchResponse =
            await fetch(
              getCartAddUrl(),
              {

                method: 'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json',

                },

                body:
                  JSON.stringify(
                    payload
                  ),

              }
            );


          const response =
            await fetchResponse.json();


          if (
            !fetchResponse.ok ||
            response.status
          ) {

            showError(
              root,
              response.description ||
                response.message ||
                'Unable to add to cart'
            );


            setButtonLabel(
              button,
              labelAdd
            );


            button.disabled =
              false;


            return;

          }


          let cart =
            response;


          try {

            cart =
              await fetch(
                `${window.Shopify?.routes?.root || '/'}cart.js`
              ).then(
                (res) =>
                  res.json()
              );


            if (
              response.sections
            ) {

              cart.sections =
                response.sections;

            }

          } catch (_error) {

            cart =
              response;

          }


          setButtonLabel(
            button,
            labelAdded
          );


          afterAdd(
            button,
            cart
          );


          window.setTimeout(
            () => {

              setButtonLabel(
                button,
                labelAdd
              );


              button.disabled =
                false;

            },
            1500
          );


        } catch (error) {

          console.error(
            error
          );


          showError(
            root,
            'Unable to add to cart'
          );


          setButtonLabel(
            button,
            labelAdd
          );


          button.disabled =
            false;

        }

      }
    );

  })();
  } catch(e) { console.error(e); }
})();

})();
